<template>
  <div>
    <NavBarGeo />
    <div class="row">
      <div class="col-sm-1">
        <v-card class="drawer-bar mx-auto" width="100%" height="100vh" tile style="position: fixed">
          <v-navigation-drawer permanent>
            <NavBarVertical @emitLoadPacientes="emitLoadPacientes" />
          </v-navigation-drawer>
        </v-card>
      </div>
      <v-navigation-drawer v-model="drawerBar" absolute temporary @input="updateDrawerState" style="padding-top: 5rem">
        <NavBarVertical @emitLoadPacientes="emitLoadPacientes" />
      </v-navigation-drawer>
      <div class="main-responsive" style="width: 100%; margin-top: 2.53rem;height: 90vh;">
        <MapGeo :dataPaciente="emitLoadPacientesData"></MapGeo>
      </div>
    </div>
  </div>
</template>
<style scoped>
.v-application--is-ltr .v-list-group--no-action>.v-list-group__items>.v-list-item[data-v-7ea7f777] {
  padding-left: 10px !important;
}

::v-deep .theme--light.v-select .v-select__selections {
  color: rgb(255 255 255 / 100%) !important;
  min-height: 10px;
}

.theme--light.v-input input,
.theme--light.v-input textarea {
  color: rgb(255, 255, 255);
}

.theme--light.v-select .v-select__selections {
  color: rgb(255, 255, 255);
  min-height: 10px;
}

.v-input__slot:before {
  border-color: white !important;
}

.theme--light.v-label {
  color: rgb(255, 255, 255);
}

.theme--light.v-icon {
  color: rgb(255, 255, 255);
}

a {
  text-decoration: none;
}

.v-divider.theme--light {
  border-color: rgb(255 255 255 / 25%);
}

a:hover {
  background-color: #ffffff10;
}

.v-list-item__title.text-h6,
.v-list-item__subtitle {
  color: white !important;
  text-decoration: none;
}

.v-list-item-navbar:hover {
  background-color: #ffffff10;
}

.v-list-item-navbar {
  margin: 0.5rem 0;
}

.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon .v-icon.notranslate.mdi.mdi-folder.theme--light,
.v-list-item__icon.v-list-group__header__prepend-icon .v-icon {
  color: white !important;
  text-decoration: none;
}

.v-list-group {
  color: white !important;
}

.v-list-group__header :hover {
  background-color: #ffffff10;
}

.v-navigation-drawer {
  background: linear-gradient(135deg,
      rgb(25 115 165),
      rgb(20 145 215),
      #0d67aa,
      #00304e) !important;
  color: white !important;
}

.main-responsive {
  padding-left: 16.78rem;
}

@media (max-width: 1024px) {
  .main-responsive {
    margin-left: 0rem;
    padding-left: 1.5rem;
  }
}

tbody tr td {
  font-size: 0.7rem;
}

.v-expansion-panel-header {
  padding: 0.5rem !important;
}

@media (max-width: 1024px) {
  .drawer-bar {
    display: none;
  }
}

/* Opcional: Mostrar el botón solo en pantallas mayores a 1024px (ej. desktops) */
@media (min-width: 1024px) {
  .drawer-bar {
    display: block;
  }
}
</style>
<script>
import NavBarGeo from "../../../components/navbar/NavBarGeo.vue";
import NavBarVertical from "../../../components/navbar/NavVerticalGeo.vue"
import { mapState, mapActions } from "vuex";
import MapGeo from "../modulos/mapgeo/index.vue"
export default {
  data() {
    return {
      emitLoadPacientesData: null
    };
  },
  methods: {
    emitLoadPacientes(datos) {
      console.log("pacientes", datos);
      this.emitLoadPacientesData = datos;
    },
    updateNavBar(datos) {
      this.drawerBar = datos;
    },
    handleRouteChange() {
      this.setDrawerBar(false);
    },
    updateDrawerState(value) {
      this.setDrawerBar(value);
    },
  },
  computed: {
    ...mapState(["drawerBar"]),
  },
  mounted() { },
  created() {
    console.log("usuario",sessionStorage.getItem("usuario"));
  },
  components: {
    NavBarGeo,
    NavBarVertical,
    MapGeo
  },
};
</script>